module.exports = __webpack_public_path__ + "img/connection-left-3.a3698a81.png";